import React from 'react';
import styles from './styles.module.scss';
import powerBlowIcon from '../../../../images/powerblow-icon.svg';
import { translate } from '../../../../localization';
import { useAppLogic } from '../../../../hooks/AppLogicHook';

const PowerBlowController = ({ customSettings, setCustomSettings }) => {
  const { sendPowerblowSettings } = useAppLogic();

  const power = customSettings.suctionPower;
  const suctionTime = customSettings.suctionTime / 1000; // Convert ms to s
  const vacuumHold = customSettings.vacuumHold / 1000;
  const pauseTime = customSettings.pauseTime / 1000;

  const handleSettingsChange = (event) => {
    const { name, value } = event.target;
    setCustomSettings((prev) => ({
      ...prev,
      [name]: name === 'suctionPower' ? +value : +value * 1000, // Convert s to ms
    }));
  };

  return (
    <div className={styles.powerBlowController}>
      <img src={powerBlowIcon} alt="powerblow" className={styles.powerBlowIcon} />
      <div className={styles.controllerInput}>
        <div className={styles.labelWrapper}>
          <span>{translate('PowerBlowController.SuctionPower')}</span>
          <span className={styles.percentage}>{power}%</span>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          name="suctionPower"
          value={customSettings.suctionPower}
          className={styles.rangeInput}
          onChange={handleSettingsChange}
          style={{
            background: `linear-gradient(to right, #ffffffb4 ${power}%, #e0e7ff66 ${power}%)`,
          }}
          disabled={customSettings.isRunning}
        />

        <div className={styles.labelWrapper}>
          <span>{translate('PowerBlowController.SuctionTime')}</span>
          <span className={styles.percentage}>{suctionTime.toFixed(1)} s</span>
        </div>
        <input
          type="range"
          min="0"
          max="10"
          step="0.5"
          name="suctionTime"
          value={suctionTime}
          className={styles.rangeInput}
          onChange={handleSettingsChange}
          style={{
            background: `linear-gradient(to right, #ffffffc4 ${suctionTime * 10}%, #e0e7ff66 ${
              suctionTime * 10
            }%)`,
          }}
          disabled={customSettings.isRunning}
        />

        <div className={styles.labelWrapper}>
          <span>{translate('PowerBlowController.VacuumHold')}</span>
          <span className={styles.percentage}>{vacuumHold.toFixed(1)} s</span>
        </div>
        <input
          type="range"
          min="0"
          max="10"
          step="0.5"
          name="vacuumHold"
          value={vacuumHold}
          className={styles.rangeInput}
          onChange={handleSettingsChange}
          style={{
            background: `linear-gradient(to right, #ffffffb4 ${vacuumHold * 10}%, #e0e7ff66 ${
              vacuumHold * 10
            }%)`,
          }}
          disabled={customSettings.isRunning}
        />

        <div className={styles.labelWrapper}>
          <span>{translate('PowerBlowController.PauseTime')}</span>
          <span className={styles.percentage}>{pauseTime.toFixed(1)} s</span>
        </div>
        <input
          type="range"
          min="0"
          max="10"
          step="0.5"
          name="pauseTime"
          value={pauseTime}
          className={styles.rangeInput}
          onChange={handleSettingsChange}
          style={{
            background: `linear-gradient(to right, #ffffffb4 ${pauseTime * 10}%, #e0e7ff66 ${
              pauseTime * 10
            }%)`,
          }}
          disabled={customSettings.isRunning}
        />
      </div>

      <div className={styles.buttonGroup}>
        <button
          className={styles.playButton}
          onClick={() =>
            setCustomSettings((prev) => {
              const newSettings = { ...prev, isRunning: !customSettings.isRunning };
              sendPowerblowSettings(newSettings);
              return newSettings;
            })
          }
        >
          {customSettings.isRunning
            ? translate('PowerBlowController.Pause')
            : translate('PowerBlowController.Play')}
        </button>
      </div>
    </div>
  );
};

export default PowerBlowController;
